var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSubcontractors(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 64,
    height: 64,
    viewBox: "0 0 31.438 25.828",
    fill: "currentColor",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_3005",
    "data-name": "Group 3005",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5267",
    "data-name": "Path 5267",
    d: "M12.479,15C8.648,15,1,16.923,1,20.739v1.435a1.439,1.439,0,0,0,1.435,1.435H22.523a1.439,1.439,0,0,0,1.435-1.435V20.739C23.958,16.923,16.31,15,12.479,15Z",
    transform: "translate(-1 2.218)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5268",
    "data-name": "Path 5268",
    d: "M4.953,11.174H17.192a.7.7,0,0,0,.7-.7v-.029a.7.7,0,0,0-.7-.7h-.387a5.735,5.735,0,0,0-2.87-4.95V6.152a.717.717,0,0,1-1.435,0V4.2A5.87,5.87,0,0,0,11.066,4a5.87,5.87,0,0,0-1.435.2V6.152a.717.717,0,0,1-1.435,0V4.789a5.735,5.735,0,0,0-2.87,4.95H4.953a.7.7,0,0,0-.7.7v.043A.7.7,0,0,0,4.953,11.174Z",
    transform: "translate(0.413 -2.565)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5269",
    "data-name": "Path 5269",
    d: "M10.679,14.3A5.739,5.739,0,0,0,16.217,10H5.14A5.739,5.739,0,0,0,10.679,14.3Z",
    transform: "translate(0.8 0.044)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5270",
    "data-name": "Path 5270",
    d: "M24.541,7.635l1.334-1.191L24.8,4.578l-1.707.56a2.845,2.845,0,0,0-.674-.387L22.059,3H19.907l-.359,1.751a3.26,3.26,0,0,0-.689.387l-1.693-.56L16.09,6.444l1.334,1.191a3.244,3.244,0,0,0,0,.746L16.09,9.6l1.076,1.865,1.722-.545a3.3,3.3,0,0,0,.617.359l.4,1.765h2.152l.387-1.751a3.416,3.416,0,0,0,.631-.359l1.707.545,1.076-1.865L24.527,8.4A3.4,3.4,0,0,0,24.541,7.635ZM20.983,9.816a1.794,1.794,0,1,1,1.794-1.794A1.794,1.794,0,0,1,20.983,9.816Z",
    transform: "translate(5.562 -3)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5271",
    "data-name": "Path 5271",
    d: "M21.283,11.134l-1.22.4a1.937,1.937,0,0,0-.474-.273L19.332,10H17.8l-.258,1.248a2.673,2.673,0,0,0-.488.273l-1.205-.4-.775,1.334.947.847a3.278,3.278,0,0,0,0,.531l-.947.875.775,1.334,1.234-.387a2.76,2.76,0,0,0,.445.258l.258,1.263h1.535l.273-1.248a2.893,2.893,0,0,0,.459-.258l1.22.387.775-1.334-.947-.875a3.278,3.278,0,0,0,0-.531l.947-.847Zm-2.726,3.731a1.277,1.277,0,1,1,1.277-1.277A1.28,1.28,0,0,1,18.557,14.864Z",
    transform: "translate(5.119 0.044)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSubcontractors);
export default __webpack_public_path__ + "static/media/subcontractors.74a9b49d841d2c29d9ffbc69b5db4b55.svg";
export { ForwardRef as ReactComponent };